import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fr } from 'vuetify/locale'

// Brand colors
const brandColors = {
  blood: '#690c07',
  bloodLight: '#8b1a12',
  bloodDark: '#4a0805',
  sand: '#d3b688',
  sandLight: '#e0c9a3',
  sandDark: '#b89c6a',
}

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'fr',
    messages: { fr },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#1a5fb4',
          secondary: '#5e5c64',
          accent: '#1a5fb4',
          error: '#c5221f',
          info: '#1a5fb4',
          success: '#188038',
          warning: '#e37400',
          blood: brandColors.blood,
          'blood-light': brandColors.bloodLight,
          'blood-dark': brandColors.bloodDark,
          sand: brandColors.sand,
          'sand-light': brandColors.sandLight,
          'sand-dark': brandColors.sandDark,
          background: '#f2f2f2',
          surface: '#ffffff',
          'surface-variant': '#eae8e4',
          'on-surface-variant': '#5e5c64',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#4d9fec',
          secondary: '#bdc1c6',
          accent: '#4d9fec',
          error: '#ea4335',
          info: '#4d9fec',
          success: '#34a853',
          warning: '#fbbc04',
          blood: brandColors.bloodLight,
          'blood-light': '#a52a2a',
          'blood-dark': brandColors.blood,
          sand: brandColors.sand,
          'sand-light': brandColors.sandLight,
          'sand-dark': brandColors.sandDark,
          background: '#121212',
          surface: '#1e1e1e',
          'surface-variant': '#2d2d2d',
          'on-surface-variant': '#bdc1c6',
        },
      },
    },
  },
  defaults: {
    VBtn: {
      variant: 'flat',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
    },
  },
})
